<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="thebiographies">
<h2 class="heading">The Biographies</h2>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// therussian_thebiographies.vue?22a4e062